import { SyncEventFormState } from '@innowise-group/core';

export const SyncEventFormDefaultValues: SyncEventFormState = {
  id: '',
};
